import { OUT_OF_STOCK } from '@/app/[locale]/product/_consts';
import type { UseWizardState } from '@/app/[locale]/product/_hooks/useWizardState/types';

import WizStepId from '../enums/WizStepId';

export const _getIsFinishNext = ({
  isAccessory,
  currentStep,
}: Partial<UseWizardState>) => {
  return !isAccessory && currentStep === WizStepId.Style;
};

export const _getIsSizeNext = ({
  isAccessory,
  currentStep,
}: Partial<UseWizardState>) => {
  const _isAccessory = Boolean(isAccessory);
  return (
    (_isAccessory && currentStep === WizStepId.Accessory) ||
    (!_isAccessory && currentStep === WizStepId.Finish)
  );
};

export const _getIsNotifyMe = ({
  stockStatus,
  isOuraRing4Wizard,
}: Partial<UseWizardState>) => {
  return stockStatus === OUT_OF_STOCK && isOuraRing4Wizard;
};

export const _getIsAddToCart = ({
  isAccessory,
  currentStep,
  stockStatus,
  isOuraRing4Wizard,
}: Partial<UseWizardState>) => {
  const isChargerOptions =
    Boolean(isAccessory) && currentStep === WizStepId.Size;
  const isGen3OutofStock = stockStatus === OUT_OF_STOCK && !isOuraRing4Wizard;

  return isChargerOptions || isGen3OutofStock;
};
